// extracted by mini-css-extract-plugin
module.exports = {"shopify-cart-icon":"ShopifyCartIcon_shopify-cart-icon__ZQTf1"};